const DividerLine = () => {
  return (
    <div className='tw-overflow-auto tw-overflow-x-hidden cm-mt-[8px] cm-mb-[8px]'>
      <hr className="tw-w-full tw-h-px tw-border-none cm-bg-[#DADBDB] dark:cm-bg-[#64748B]"></hr>
    </div>
  )
}

export default DividerLine
